export const name = 'viewerManagerCalculator' as const

export const ViewerManagerApiImplementor = Symbol('ViewerManagerApiImplementor')
export const ViewerManagerApi = Symbol('ViewerManagerApi')
export const CarmiInstance = Symbol('CarmiInstance')
